import React from 'react';
import logoTypeSvg from '../assets/promptilia_logo_type.svg';
import logoPng from '../assets/promtilia_logo.png';

interface LogoProps {
  variant?: 'icon' | 'full';
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({
  variant = 'icon',
  size = 'md',
  className = '',
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
    '2xl': 'w-20 h-20',
    '3xl': 'w-24 h-24',
  };

  // For full logo variant, use responsive sizing to maintain aspect ratio
  const fullLogoSizes = {
    sm: 'h-6 w-auto',
    md: 'h-8 w-auto',
    lg: 'h-12 w-auto',
    xl: 'h-24 w-auto',
    '2xl': 'h-20 w-auto',
    '3xl': 'h-24 w-auto',
  };

  const logoSrc = variant === 'full' ? logoTypeSvg : logoPng;

  // Choose appropriate size class based on variant
  const sizeClass =
    variant === 'full' ? fullLogoSizes[size] : sizeClasses[size];

  return (
    <img
      src={logoSrc}
      alt="Promptilia"
      className={`${sizeClass} ${className}`}
      loading="lazy"
    />
  );
};

export default Logo;
